<template>
  <div>
    <div class="main-fof">
      <div class="fof">
        <h1>Error 404</h1>
        <p>Page not found</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/404.vue